namespace Matrix.Dashboards {
    export interface DashboardForm {
        DashboardCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        ParamBindingsOnToolbar: Serenity.SelectEditor;
        NavigationPath: Serenity.StringEditor;
        NavigationOrder: Serenity.IntegerEditor;
        NavigationPermission: Serenity.StringEditor;
        DefaultForRoles: Serenity.ServiceLookupEditor;
        DefaultForUsers: Serenity.ServiceLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class DashboardForm extends Serenity.PrefixedContext {
        static formKey = 'Dashboards.Dashboard';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DashboardForm.init)  {
                DashboardForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.SelectEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(DashboardForm, [
                    'DashboardCode', w0,
                    'Name', w0,
                    'Description', w0,
                    'ParamBindingsOnToolbar', w1,
                    'NavigationPath', w0,
                    'NavigationOrder', w2,
                    'NavigationPermission', w0,
                    'DefaultForRoles', w3,
                    'DefaultForUsers', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
